import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'split'
})
export class SplitPipe implements PipeTransform {

  // https://toddmotto.com/angular-pipes-custom-pipes
  transform(values: string, separator: string = ','): string[] {
    return values.splitTrim(separator)
  }
}


// https://stackoverflow.com/questions/39877156/how-to-extend-string-prototype-and-use-it-next-in-typescript
declare global {
  interface String {
    splitTrim(separator?: string): string[]
  }
}

String.prototype.splitTrim = function(separator?: string): string[] {
  return this.split(separator ? separator : ',').map((value: string) => value.trim()).filter((value: string) => value.length > 0)
}
